module.exports = __webpack_public_path__ + "img/hr-lab-integration.07b666c6.png";